<template>
  <main class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">包裹入库预报</span>
    </div>
    <div class="search-one" style="margin-top: 70px;">
      <Form :model="form_data" :label-width="130">
        <FormItem label="快递单号" class="ivu-form-item-required">
          <input class="w300 ivu-input ivu-input-default" ref="waybill_code" v-model="form_data.waybill_code"
            onKeyUp="value=value.replace(/[\W]/g,'')" @keyup="waybillChanged($event,'waybill_code')" placeholder="" />
        </FormItem>
        <FormItem label="子账户" class="ivu-form-item-required">
          <input class="w300 ivu-input ivu-input-default" ref="client_code" v-model="form_data.client_code"
            onKeyUp="value=value.replace(/[\W]/g,'')" @keyup="waybillChanged($event,'client_code')" placeholder="" />
        </FormItem>
      </Form>
    </div>
    <Table class="mt20" border :columns="detail_columns" :data="detail_list">
       <template slot-scope="{ row, index }" slot="images">
          <span class="item-img mr10 fl" v-for="(v,i) in row.image_arr" :key="i" :src="v" >
            <!-- <img :src="v"/> -->
            <el-image
                style="width: 30px; height: 30px;margin-top: 10px;"
                :src="v"
                :preview-src-list="row.image_arr">
              </el-image>
            <Icon v-if="row.$isEdit" @click="delImg(index,i)" class="i-colse" type="ios-close-circle" size="16"/>
          </span>
          <Icon class="fl ml10" v-if="row.image_arr.length<5 && row.$isEdit" @click="triggerFile(index)" type="ios-add-circle-outline" size="24"/>
      </template>
    </Table>
    <Button class="mt10" @click="addWaybillDetail()">
      <Icon type="md-add" />
    </Button>
    <div class="search-one" style="margin-top: 70px;">
      <div class="search-item">
        <button class="ivu-btn ivu-btn fr ml20" @click="cancelForecast">取消</button>
        <button class="ivu-btn ivu-btn-primary fr" @click="confirmForecast">确定预报</button>
      </div>
    </div>
    <Modal :title="'上传照片'" v-model="upload_pic" width="600">
      <div class="details f14">
      </div>
      <div slot="footer">
      </div>
    </Modal>

    <form id="uploadForm" style="display: none;"><input type="file" id="file" @change="uploadFile($event)" >
    		</form>
  </main>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        index:0,//表格图片当前索引
        form_data: {
          warehouse_id: '',
          waybill_code: ''
        },
        upload_pic: false,
        detail_list: [],
        detail_columns: [{
            title: 'UPC',
            key: 'sku',
            tooltip: true,
            width: 200,
            render: (h, params) => {
              return h('div', {
                  style: {
                    height: '100%',
                  },
                },
                [h('input', {
                    style: {
                      height: '22px',
                      border: '1px solid #dcdee2',
                      display: params.row.$isEdit ? 'block' : 'none',
                    },
                    domProps: {
                      value: params.row.sku,
                    },
                    props: {
                      value: params.row.sku,
                    },
                    on: {
                      "blur": () => { // 离焦事件
                        this.detail_list[params.index].sku = event.target.value;
                      }
                    }
                  }),
                  h('div', {
                    style: {
                      display: params.row.$isEdit ? 'none' : 'block',
                      height: '22px',
                    }
                  }, params.row.sku)
                ])
            }
          },
          {
            title: '品名',
            width: 250,
            key: 'product_name',
            tooltip: true,
            render: (h, params) => {
              return h('div', {
                  style: {
                    height: '100%',
                  },
                },
                [h('input', {
                    style: {
                      height: '22px',
                      border: '1px solid #dcdee2',
                      display: params.row.$isEdit ? 'block' : 'none',
                    },
                    domProps: {
                      value: params.row.product_name,
                    },
                    props: {
                      value: params.row.product_name,
                    },
                    on: {
                      "blur": () => { // 离焦事件
                        this.detail_list[params.index].product_name = event.target.value;
                      }
                    }
                  }),
                  h('div', {
                    style: {
                      display: params.row.$isEdit ? 'none' : 'block',
                      height: '22px',
                    }
                  }, params.row.product_name)
                ])
            }
          },
          {
            title: '数量',
            key: 'count',
            tooltip: true,
            width: 100,
            render: (h, params) => {
              return h('div', {
                  style: {
                    height: '100%',
                  },
                },
                [h('input', {
                    style: {
                      height: '22px',
                      width: '60px',
                      border: '1px solid #dcdee2',
                      display: params.row.$isEdit ? 'block' : 'none',
                    },
                    domProps: {
                      value: params.row.count,
                    },
                    props: {
                      value: params.row.count,
                    },
                    on: {
                      "blur": () => { // 离焦事件
                        this.detail_list[params.index].count = event.target.value;
                      }
                    }
                  }),
                  h('div', {
                    style: {
                      display: params.row.$isEdit ? 'none' : 'block',
                      height: '22px',
                    }
                  }, params.row.count)
                ])
            }
          },
          {
            title: '图片',
            key: 'images',
            width: 300,
            slot: "images"
          },
          {
            title: '备注',
            key: 'remark',
            render: (h, params) => {
              return h('div', {
                  style: {
                    height: '100%',
                  },
                },
                [h('input', {
                    style: {
                      height: '22px',
                      width: '100%',
                      border: '1px solid #dcdee2',
                      display: params.row.$isEdit ? 'block' : 'none',
                    },
                    domProps: {
                      value: params.row.remark,
                    },
                    props: {
                      value: params.row.remark,
                    },
                    on: {
                      "blur": () => { // 离焦事件
                        this.detail_list[params.index].remark = event.target.value;
                      }
                    }
                  }),
                  h('div', {
                    style: {
                      display: params.row.$isEdit ? 'none' : 'block',
                      height: '22px',
                    }
                  }, params.row.remark)
                ])
            }
          },
          {
            title: '操作',
            width: 200,
            render: (h, params) => {
              return h('div', {
                  style: {
                    height: '100%',
                  },
                },
                [h('button', {
                    style: {
                      height: '22px',
                      padding: '10px',
                      display: params.row.$isEdit ? 'inline' : 'none',
                    },
                    on: {
                      click: () => {

                        if (!this.detail_list[params.index].sku) {
                          this.$Message.error('请录入UPC');
                          return;
                        }
                        if (this.detail_list[params.index].sku.length!=12 && this.detail_list[params.index].sku.length!=13) {
                          this.$Message.error('请检查UPC长度');
                          return;
                        }

                        if (!this.detail_list[params.index].product_name) {
                          this.$Message.error('请录入商品名称');
                          return;
                        }

                        if (!this.detail_list[params.index].count) {
                          this.$Message.error('请录入商品数量');
                          return;
                        }
                        if (!this.detail_list[params.index].image_arr.length) {
                          this.$Message.error('请上传图片');
                          return;
                        }
                        this.detail_list[params.index].image_urls = this.detail_list[params.index].image_arr.join();
                        this.detail_list[params.index].$isEdit = false;
                      },
                    }
                  }, "保存"),
                  h('button', {
                    style: {
                      height: '22px',
                      padding: '10px',
                      display: params.row.$isEdit ? 'inline' : 'none',
                    },
                    on: {
                      click: () => {
                        this.detail_list[params.index].$isEdit = false;
                      },
                    }
                  }, "取消"),
                  h('button', {
                    style: {
                      height: '22px',
                      padding: '10px',
                      display: params.row.$isEdit ? 'none' : 'inline',
                    },
                    on: {
                      click: () => {
                        this.detail_list[params.index].$isEdit = true;
                      },
                    }
                  }, "编辑"),
                  h('button', {
                    style: {
                      height: '22px',
                      padding: '10px',
                      display: params.row.$isEdit ? 'none' : 'inline',
                    },
                    on: {
                      click: () => {

                        //delete from database
                        this.detail_list.splice(params.index, 1);
                      },
                    }
                  }, "删除")
                ])
            }
          }
        ]
      }
    },
    methods: {
      delImg(pi,i){ //删除图片
        this.detail_list[pi].image_arr.splice(i,1)
      },
      triggerFile(index) { //触发input
        this.index = index;
        $("#file").trigger('click');
      },
      uploadFile(event){
        const _this=this;
        let formData=new FormData();
        let _file = event.target.files[0];
        formData.append('file',_file);
        this.$axios.post("/common/image/upload",formData,{
          headers:{
            "Content-Type":"application/json",
            noShowError: true
          }
        }).then(res=>{
          console.log(res)
          this.detail_list[this.index].image_arr.push(res)
          document.getElementById("uploadForm")&&document.getElementById("uploadForm").reset();//清除input
        })
      },
      waybillChanged(e, name) {
        this.form_data[name] = e.target.value.toUpperCase()
      },
      getDetail() { //查看详情
        this.$axios.get("/WarehouseIn/bill/detail", {
          params: {
            waybill_code: this.form_data.waybill_code
          }
        }).then(res => {
          if (res.success && res.data && res.data.length) {
            this.detail_list = res.data;
          }
          this.show_detail = true;
        })
      },
      addWaybillDetail() {

        if (!this.form_data.waybill_code || this.form_data.waybill_code == '' || this.form_data.waybill_code == ' ') {
          this.$Message.error('请先录入快递单号');
          return;
        }

        if (!this.form_data.client_code || this.form_data.client_code == '' || this.form_data.client_code == ' ') {
          this.$Message.error('请选择子账户')
          return;
        }

        let item = {};
        item.waybill_code = this.form_data.waybill_code;
        item.$isEdit = true;
        item.image_arr = []
        this.detail_list.push(item);
      },
      saveWaybillDetail() {

      },
      /*
       * 取消
       */
      cancelForecast() {
        this.$router.replace({
          path: "/tuihuozhijian/in"
        });

      },

      confirmForecast() {

        let waybillDetails = [];
        this.detail_list.forEach(function(item, index) {
          let newItem = {};
          newItem.waybill_code = item.waybill_code;
          newItem.product_name = item.product_name;
          newItem.count = item.count;
          newItem.remark = item.remark;
          newItem.sku = item.sku;
          newItem.image_urls = item.image_urls;
          waybillDetails.push(newItem)
        });
        let params = 'waybill_code=' + this.form_data.waybill_code + '&client_code='+this.form_data.client_code + '&biz_type=' + this.form_data.biz_type + '&warehouse_id=' + this.form_data.warehouse_id;
        this.$axios.post("/warehouse/waybill/forecast?"+params, waybillDetails,{
          headers:{
            "Content-Type":"application/json",
          }
        }).then(res => {
          if (res.success && res.data) {
            this.$Message.info('提交成功');
            this.$router.replace({
              path: "/tuihuozhijian/in"
            });

          }
        })
      },
    },
    created() {
      this.form_data.warehouse_id = localStorage.getItem('warehouse_id');
      this.form_data.client_code = localStorage.getItem('client_code') || '';
      this.form_data.biz_type = 2;
      if (this.form_data.warehouse_id) {

        if (this.$route.query.waybill_code) {
          this.form_data.waybill_code = this.$route.query.waybill_code;
          this.getDetail();
        }
      } else {
        this.$Message.info('请选择仓库')
      }

      if (!this.form_data.client_code || this.form_data.client_code == '' || this.form_data.client_code == ' ') {
        this.$Message.info('请选择子账户')
      }
    }
  }
</script>

<style scoped>
  .item-img{
    display: inline-block;
    width: 40px;
    height: 40px;
    position: relative;
  }
  .item-img img{
    width: 30px;
    height: 30px;
    margin-top: 5px;
  }
  .item-img .i-colse{
    position: absolute;
    top: 0px;
    right: 0px;
  }
  .btn-scan:visited,
  .btn-scan:active,
  .btn-scan:focus {
    color: #ffffff;
  }

  .btn-scan {
    line-height: 40px;
    margin-top: 40px;
  }

  .inbill-code {
    width: 600px;
    padding: 20px 0;
    text-align: center;
    font-size: 20px;
    background-color: #f6f8f9;
    margin-bottom: 20px;
  }

  .client-code {
    width: 200px;
    padding: 10px 30px;
    font-size: 15px;
    background-color: #f6f8f9;
  }

  .client-code span {
    display: inline-block;
    font-size: 30px;
    padding: 10px 0;
    font-weight: bold;
  }

  .btn-print {
    padding: 10px 30px;
    height: auto;

  }
</style>



// WEBPACK FOOTER //
// src/pages/tuihuozhijian/in/forecast.vue